import { Handle, NodeProps, Position } from 'reactflow';
import { Database } from 'lucide-react';
import { PipelineNodeData } from '../../types/pipeline';

export default function SourceNode({ data, selected }: NodeProps<PipelineNodeData>) {
  return (
    <div
      className={`rounded-lg border bg-white px-3 py-2 shadow-sm ${
        selected ? 'border-blue-500 ring-2 ring-blue-200' : 'border-blue-200'
      }`}
    >
      <Handle type="source" position={Position.Right} className="!bg-blue-500" />
      <div className="flex items-center gap-2 text-sm font-semibold text-blue-700">
        <Database className="h-4 w-4" />
        <span>{data.label}</span>
      </div>
      {data.description && (
        <p className="mt-1 text-xs text-slate-500">{data.description}</p>
      )}
    </div>
  );
}
